import React from 'react'

const ErrorView = ({ status, message }) => {
    if (status === 'no-appointment-required') {
        return (
            <div className="container py-4">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8">
                        <div className="alert alert-info" role="alert">
                            <h4 className="alert-heading">No Appointment Required</h4>
                            <p className="mb-0">No dock scheduling appointment is required for this shipment.</p>
                            <p className="mb-0">If you believe this is incorrect, please contact your ShippersEdge administrator.</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    if (status === 'no-shipment') {
        return (
            <div className="container py-4">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8">
                        <div className="alert alert-warning" role="alert">
                            <h4 className="alert-heading">Shipment Not Found</h4>
                            <p className="mb-0">This scheduling link may be expired or invalid.</p>
                            <p className="mb-0">Please check with your dispatcher or contact ShippersEdge support.</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="container py-4">
            <div className="row justify-content-center">
                <div className="col-12 col-md-8">
                    <div className="alert alert-danger" role="alert">
                        <h4 className="alert-heading">Something went wrong</h4>
                        {message && <p>{message}</p>}
                        <button className="btn btn-primary" onClick={() => window.location.reload()}>
                            Reload Page
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ErrorView
